import React, { Component } from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Alert from 'react-s-alert';

//Se accede a firebase
const database = firebase.database();

//Estilo para los modales 
const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      transform             : 'translate(-50%, -50%)',
      width                 : '450px'
      
    }
  };


class Modal_Costos extends Component{
    constructor(){
        super();
        this.state={
            isActive:false,
            codigo:'',
            descripcion:'',
            responsable:'',
            area:'',
            empresaUID:''
        };
        //Se realiza bind para que las funciones no den error a la ejecucion
        this.handleSubmit=this.handleSubmit.bind(this);

        //Se obtiene los datos de los nodos
        this.costosRef=database.ref().child('CentroCosto');
    }

    componentWillMount(){
        let uid = firebase.auth().currentUser.uid;
        this.setState({empresaUID:uid})
    }

    //manejo del post del form
    handleSubmit=(event)=>{

        //Se verifica si hay algun registro que tenga un codigo igual
        this.costosRef.orderByChild('codigo').equalTo(this.Codigo.value).once("value").then(snapshot=>{
    
            if(snapshot.exists()){
					
                Alert.warning('Ya hay un centro de costo con este codigo', {
                    effect: 'genie',
                    position: 'bottom-right',
                    timeout:2000			
                });
                
            }
            else{ 
                this.costosRef.push({
                
                        codigo:this.Codigo.value,
                        descripcion:this.Descripcion.value,
                        responsable:this.Responsable.value,
                        area:this.Area.value,
                        empresa:this.state.empresaUID
                });	
        
                            
                this.toggleModal();
                
                Alert.success('Datos guardados correctamente', {
                    effect: 'genie',
                    position: 'bottom-right',
                    timeout:2000			
                });
            }
        });
        event.preventDefault();
    }

    //Manejo de Estado de la apertura del modal 

    toggleModal=()=>{
		
		this.setState({
			isActive:!this.state.isActive,
			foto:null,
			uploadValue:0
		})
    }
    
    //Validaciones de solo numeros
    handleKeyPressNumeros(e){
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
    }
    
    //Validacion solo letras
    handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32 && tecla!=91 ){			
			e.preventDefault();		
		}	
	}

    render() {
        return (
            <div className="ingreso_costos">
                <button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
                
                <Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
                <h3>Agregar Centro de costos</h3>
                    <hr/>
                    <form method="POST" action="" onSubmit={this.handleSubmit}>
                        
                        <div className="form-group">
                            <label htmlFor="codigo">Codigo</label>
                            <input type="text" name="codigo" className="form-control"
                            placeholder="codigo" required autoComplete="off"
                            ref={input => {this.Codigo=input;}}
                            onKeyPress={this.handleKeyPressNumeros}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="desc">Descripción</label>
                            <input type="text" name="desc" className="form-control"
                            placeholder="desc" required autoComplete="off"
                            ref={input => {this.Descripcion=input;}}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="resp">Responsable</label>
                            <input type="text" name="resp" className="form-control"
                            placeholder="resp" required autoComplete="off"
                            ref={input => {this.Responsable=input;}}
                            onKeyPress={this.handleKeyPressLetras}
                            />
					    </div>
                        <div className="form-group">
                            <label htmlFor="area">Area</label>
                            <input type="text" name="area" className="form-control"
                            placeholder="area" required autoComplete="off"
                            ref={input => {this.Area=input;}}
                            onKeyPress={this.handleKeyPressLetras}
                            />
					    </div>
                        <button className="btn btn-primary buttons" type="submit" >Guardar</button>
					    <button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
                    </form>
                </Modal>
            </div>
        );
    }
}

export default Modal_Costos;


// WEBPACK FOOTER //
// ./src/Components/Costos/modal_costos.js